import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import ICONS from '@/common-utils/enums/icons';
import Icon from '../renders/icon/Icon';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';


/**
 * @param root0
 * @param root0.className
 * @returns {JSX} RadioGroup
 */
function RadioGroup({ className, ...props }) {
    return (
        <RadioGroupPrimitive.Root
            data-slot='radio-group'
            className={cn('grid gap-4', className)}
            {...props}
        />
    );
}

/**
 * @param root0
 * @param root0.className
 * @returns {JSX} RadioGroupItem
 */
function RadioGroupItem({ className, ...props }) {
    return (
        <RadioGroupPrimitive.Item
            data-slot='radio-group-item'
            className={cn(
                'border-gray-400 text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20',
                'dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0',
                'rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}
        >
            <RadioGroupPrimitive.Indicator
                data-slot='radio-group-indicator'
                className='relative flex items-center justify-center'
            >
                <Icon
                    className='absolute top-1/2 left-1/2 size-3 -translate-x-1/2 -translate-y-1/2 text-success'
                    icon={ICONS.CIRCLE}
                    filled
                />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    );
}

RadioGroup.propTypes = {
    className: PropTypes.string
};

RadioGroupItem.propTypes = {
    className: PropTypes.string
};

export { RadioGroup, RadioGroupItem };
